/**
 *
 * Asynchronously loads the component for InvitationHistoryPage
 *
 */

import { lazyLoad } from 'utils/loadable';

export const InvitationHistoryPage = lazyLoad(
  () => import('./index'),
  module => module.InvitationHistoryPage,
);
